export default __webpack_public_path__ + "static/media/under_construction_dox.e0f6ea3b.png";